// @ts-expect-error utils export is missing from types
import { Layout, utils } from 'react-grid-layout';

export const LayoutMode: Record<string, { id: string; name: string; icon: string }> = {
  GRID: { id: 'GRID', name: 'Grid view', icon: 'grid-view' },
  LIST: { id: 'LIST', name: 'Stacked view', icon: 'list' }
};
Object.defineProperties(LayoutMode, {
  DEFAULT: {
    enumerable: false,
    get() {
      return this.GRID;
    }
  }
});

/**
 * utils are missing from react-grid-layout types, so we re-export the ones we need with proper types
 * this won't be needed when we upgrade to react-grid-layout v2
 */

export const compact = utils.compact as (
  layout: Layout[],
  compactType: 'vertical' | 'horizontal',
  cols: number
) => Layout[];
